import { useState } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import "../0.styles.css";
import { Button, Grid, Typography } from "@mui/material";
import { instance } from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import { useNavigate, useSearchParams } from "react-router-dom";

function UsuarioRecovery() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [dialog, setDialog] = useState({ title: "", text: "" });
  const [openDialog, setOpenDialog] = useState(false);
  const [sendToken, setSendtoken] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [verifyPasswordError, setVerifyPasswordError] = useState(false);

  function validatePassword(password) {
    // Verifica que la cadena tenga un largo mínimo de 8 caracteres
    if (password.length < 8) {
      setErrorText("La contraseña debe tener por lo menos 8 caracteres.");
      return false;
    }

    // Verifica que la cadena contenga por lo menos una letra mayúscula
    if (!/[A-Z]/.test(password)) {
      setErrorText(
        "La contraseña debe contener por lo menos una letra mayúscula, una minúscula, un número y uno o más de los siguiente caracteres espciales !@#$%&_"
      );
      return false;
    }

    // Verifica que la cadena contenga por lo menos una letra minúscula
    if (!/[a-z]/.test(password)) {
      setErrorText(
        "La contraseña debe contener por lo menos una letra mayúscula, una minúscula, un número y uno o más de los siguiente caracteres espciales !@#$%&_"
      );
      return false;
    }

    // Verifica que la cadena contenga por lo menos un número
    if (!/[0-9]/.test(password)) {
      setErrorText(
        "La contraseña debe contener por lo menos una letra mayúscula, una minúscula, un número y uno o más de los siguiente caracteres espciales !@#$%&_"
      );
      return false;
    }

    // Verifica que la cadena contenga por lo menos un caracter especial
    if (!/[!@#$%&_]/.test(password)) {
      setErrorText(
        "La contraseña debe contener por lo menos una letra mayúscula, una minúscula, un número y uno o más de los siguiente caracteres espciales !@#$%&_"
      );
      return false;
    }

    // La cadena cumple con todos los requisitos
    setErrorText("");
    return true;
  }

  const verifyPassword = () => {
    const password = document.querySelector("#password").value;
    const confirmation = document.querySelector("#password_confirmation").value;
    if (password !== confirmation) {
      setErrorText("Error: La contraseña y su confirmación no son iguales.");
      return false;
    } else {
      setErrorText("");
      return true;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!verifyPassword()) return;
    const info = e.target;
    instance
      .post("/auth/changePassword", {
        token: searchParams.get("token"),
        password: info.password.value,
      })
      .then((res) => {
        setDialog({
          title: "Operación completada",
          text: "Se ha recuperado exitosamente la contraseña.",
          redirect: true,
          page: "/Login",
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
            redirect: true,
            page: "/Login",
          });
        } else {
          setDialog({
            title: "ERROR",
            text: err.response.data.message,
            redirect: true,
            page: "/Login",
          });
        }
      })
      .finally(() => {
        setOpenDialog(true);
      });
  };

  return (
    <>
      <Container
        component="main"
        maxWidth="sm"
        className="bordered-box"
        sx={{
          padding: "4px",
          marginTop: 8,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: 4,
            marginBottom: 4,
          }}
        >
          <Typography component="h1" variant="h5">
            Recuperación de contraseña
          </Typography>
          <Grid
            container
            component="form"
            onSubmit={handleSubmit}
            spacing={2}
            mt={1}
          >
            <Grid item xs={12} sm={6}>
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Contraseña"
                type="password"
                id="password"
                onChange={(e) => {
                  setPasswordError(!validatePassword(e.target.value));
                }}
                error={passwordError}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="normal"
                required
                fullWidth
                name="password_confirmation"
                label="Confirmar contraseña"
                type="password"
                id="password_confirmation"
                onChange={() => setVerifyPasswordError(!verifyPassword())}
                error={verifyPasswordError}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <Typography
                component="p"
                variant="overline"
                xs={{ alignText: "center" }}
                color="red"
              >
                {errorText}
              </Typography>
              <Box sx={{display:"flex", justifyContent:"center"}}>
                <Button type="submit" variant="contained">
                  Recuperar contraseña
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </>
  );
}

export { UsuarioRecovery };
